import PropTypes from 'prop-types';
import { Button } from '@evertrue/et-components';
import { useGlobalDrawerProvider } from 'components/drawer/context/global-drawer-context';
import { trackOutreachAction } from 'apps/outreach/utils/utils';

const ThreadListFooter = ({ threadReplies = [] }) => {
  const { addDrawer } = useGlobalDrawerProvider();
  const lastEmail = threadReplies[threadReplies.length - 1];

  return (
    <div style={{ margin: '20px 40px' }}>
      <Button
        type="secondary"
        onClick={() => {
          trackOutreachAction('open_emailer');
          // Remove email_attachments to prevent attachments from being carried over to new reply
          const { email_attachments, ...emailWithoutAttachments } = lastEmail || {};
          addDrawer('emailer', {
            email: emailWithoutAttachments,
          });
        }}
      >
        Reply
      </Button>
    </div>
  );
};

ThreadListFooter.propTypes = {
  threadReplies: PropTypes.array.isRequired,
};

export default ThreadListFooter;
